import script from "./TermConditionPrivacyPolicy.vue.vue?vue&type=script&setup=true&lang=js"
export * from "./TermConditionPrivacyPolicy.vue.vue?vue&type=script&setup=true&lang=js"

import "./TermConditionPrivacyPolicy.vue.vue?vue&type=style&index=0&id=6da08a02&scoped=true&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6da08a02"]])

export default __exports__